import { useCallback, useMemo, useState } from 'react';

const DEFAULT_PAGE_SIZE = 25;

// Local pagination state for list screens.
export const usePagination = ({ initialPage = 1, initialPageSize = DEFAULT_PAGE_SIZE } = {}) => {
  const [page, setPage] = useState(initialPage);
  const [pageSize, setPageSize] = useState(initialPageSize);

  const next = useCallback(() => setPage((p) => p + 1), []);
  const prev = useCallback(() => setPage((p) => Math.max(1, p - 1)), []);
  const reset = useCallback(() => setPage(initialPage), [initialPage]);

  const changePageSize = useCallback((size) => {
    setPageSize(size);
    setPage(1);
  }, []);

  return useMemo(
    () => ({ page, pageSize, setPage, setPageSize: changePageSize, next, prev, reset }),
    [page, pageSize, setPage, changePageSize, next, prev, reset],
  );
};
